import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('quote',
  '/plans/quote',
  'quote')
const reducer = generator.generate()

export default reducer

